<section class="login-shell">
  <div class="login-panel">
    <div class="login-brand">
      <img class="login-brand__logo" src="assets/footer.png" alt="HealthFinder" width="240" height="59">
    </div>

    <div class="login-card">
      <h1>Iniciar sesi&oacute;n</h1>
      <form class="login-form" (ngSubmit)="onSubmit()" #loginForm="ngForm">
        <div class="login-field">
          <label for="usuario">Correo electr&oacute;nico</label>
          <div class="input-wrap">
            <span class="input-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M4 6.5h16a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z"
                  stroke="currentColor"
                  stroke-width="1.6" />
                <path
                  d="m3 8 9 6 9-6"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            <input
              type="email"
              autocomplete="username"
              name="usuario"
              id="usuario"
              placeholder="correo@ejemplo.com"
              [(ngModel)]="login_request.usuario"
              required>
          </div>
        </div>

        <div class="login-field">
          <label for="password">Contrase&ntilde;a</label>
          <div class="input-wrap password-wrap">
            <span class="input-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <rect x="4" y="10" width="16" height="10" rx="2" stroke="currentColor" stroke-width="1.6" />
                <path d="M8 10V7a4 4 0 1 1 8 0v3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
              </svg>
            </span>
            <input
              [type]="showPassword ? 'text' : 'password'"
              name="password"
              autocomplete="current-password"
              id="password"
              placeholder="********"
              [(ngModel)]="login_request.password"
              required>
            <button
              type="button"
              (click)="togglePassword()"
              class="toggle-button"
              [attr.aria-label]="showPassword ? 'Ocultar contrase&ntilde;a' : 'Mostrar contrase&ntilde;a'">
              <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a10.05 10.05 0 012.14-3.413m1.513-1.515A9.953 9.953 0 0112 5c4.477 0 8.268 2.943 9.542 7a10.05 10.05 0 01-4.14 5.712M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3 3l18 18" />
              </svg>
            </button>
          </div>
        </div>

        <div *ngIf="errorMessage" class="login-error" role="alert">
          {{ errorMessage }}
        </div>

        <button type="submit" class="login-submit" [disabled]="loginForm.invalid">
          Iniciar sesi&oacute;n
        </button>
      </form>
    </div>


  </div>
</section>

<ngx-spinner
  [name]="spinnerName"
  bdColor="rgba(243, 244, 245, 0.55)"
  class="app-loading-spinner"
  aria-label="Cargando"
  role="status"
  aria-live="polite"
  template="<img class='app-loading-spinner__image' src='assets/loader/healthfinder-tres-puntos.svg' width='160' height='160' alt='' aria-hidden='true'>">
</ngx-spinner>
